import { Custom } from '@clearkit/icons';

import { useEntitlements } from '~/hooks/account';
import useOnboardingStatus from '~/hooks/account/useOnboardingStatus';

import { HomeHeading } from '../HomeHeading';
import { StepDataMapping, StepSetupForms } from '../HomeNextSteps';

export const HomeSidebarNextSteps = () => {
  const {
    hasEnrichmentFieldMappings,
    hasFormConnectors,
    loading,
  } = useOnboardingStatus();
  const { hasAccessForms, hasAccessEnrichment } = useEntitlements();

  const hasNoFeatures = hasAccessForms || hasAccessEnrichment;
  const isSectionComplete = hasFormConnectors && hasEnrichmentFieldMappings;

  if (hasNoFeatures || isSectionComplete || loading) return null;

  return (
    <section className="pt-8 space-y-8">
      <HomeHeading>
        <Custom height={16} width={16} /> Next steps with Clearbit
      </HomeHeading>
      {!hasEnrichmentFieldMappings ? <StepDataMapping /> : null}
      {!hasFormConnectors ? <StepSetupForms /> : null}
    </section>
  );
};
